import { baseApi } from '../../core/baseApi';
import type {
    MessageGuardrail,
    ScanResult,
    GuardrailsResponse,
    ScanResponse,
} from './types';

// Re-export types for consumers
export type { MessageGuardrail, GuardrailMatch, ScanResult } from './types';

// RTK Query endpoints
export const guardrailsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // Get all active guardrails for client-side scanning
        // Cached for 24 hours (86400 seconds)
        getGuardrails: builder.query<MessageGuardrail[], void>({
            query: () => '/message-guardrails',
            transformResponse: (response: GuardrailsResponse): MessageGuardrail[] => {
                if (response && response.data) {
                    return response.data;
                }
                return [];
            },
            providesTags: ['Guardrails'],
            keepUnusedDataFor: 86400, // 24 hours cache
        }),

        // Server-side scan (backup endpoint)
        scanText: builder.mutation<ScanResult, { text: string }>({
            query: ({ text }) => ({
                url: '/message-guardrails/scan',
                method: 'POST',
                body: { text }
            }),
            transformResponse: (response: ScanResponse): ScanResult => {
                if (response && response.data) {
                    return response.data;
                }
                return {
                    hasWarnings: false,
                    matches: [],
                    highCount: 0,
                    mediumCount: 0,
                    lowCount: 0
                };
            }
        })
    }),
    overrideExisting: true
});

export const {
    useGetGuardrailsQuery,
    useScanTextMutation
} = guardrailsApi;
